import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function AddCircleIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
      >
        <g clipPath="url(#clip0_3777_10368)">
          <path
            d="M24 14.001C22.9 14.001 22 14.901 22 16.001V22.001H16C14.9 22.001 14 22.901 14 24.001C14 25.101 14.9 26.001 16 26.001H22V32.001C22 33.101 22.9 34.001 24 34.001C25.1 34.001 26 33.101 26 32.001V26.001H32C33.1 26.001 34 25.101 34 24.001C34 22.901 33.1 22.001 32 22.001H26V16.001C26 14.901 25.1 14.001 24 14.001ZM24 4.00098C12.96 4.00098 4 12.961 4 24.001C4 35.041 12.96 44.001 24 44.001C35.04 44.001 44 35.041 44 24.001C44 12.961 35.04 4.00098 24 4.00098ZM24 40.001C15.18 40.001 8 32.821 8 24.001C8 15.181 15.18 8.00098 24 8.00098C32.82 8.00098 40 15.181 40 24.001C40 32.821 32.82 40.001 24 40.001Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_3777_10368">
            <rect
              width="48"
              height="48"
              fill="none"
              transform="translate(0 0.000976562)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
